import _VolumeUp from "@mui/icons-material/VolumeUp";
import _VolumeOff from "@mui/icons-material/VolumeOff";
import React, { useMemo } from 'react';
import { ButtonContainer, DEFAULT_ICON_STYLES, getDisabledIconStyles, getShadowIconStyles, IconButtonLabel, IconButtonWrapper } from 'app/components/tv/customControls/SharedCustomControlsStyles';
export const MuteToggle = _ref => {
  let {
    muted,
    toggleMute,
    forceMuted,
    labeled
  } = _ref;
  const iconStyles = useMemo(() => {
    let styles = DEFAULT_ICON_STYLES;
    if (forceMuted) {
      styles = getDisabledIconStyles(styles);
    }
    if (labeled) {
      styles = getShadowIconStyles(styles);
    }
    return styles;
  }, [forceMuted, labeled]);
  const ToggleButton = /*#__PURE__*/React.createElement(ButtonContainer, {
    onClick: toggleMute,
    disabled: forceMuted,
    title: muted ? 'Stummschaltung aufheben' : 'Stummschalten'
  }, muted ? /*#__PURE__*/React.createElement(_VolumeOff, {
    style: iconStyles
  }) : /*#__PURE__*/React.createElement(_VolumeUp, {
    style: iconStyles
  }));
  if (!labeled) {
    return ToggleButton;
  }
  return /*#__PURE__*/React.createElement(IconButtonWrapper, {
    "data-sentry-element": "IconButtonWrapper",
    "data-sentry-component": "MuteToggle",
    "data-sentry-source-file": "MuteToggle.tsx"
  }, ToggleButton, /*#__PURE__*/React.createElement(IconButtonLabel, {
    variant: "body1",
    "data-sentry-element": "IconButtonLabel",
    "data-sentry-source-file": "MuteToggle.tsx"
  }, "Stumm"));
};